import {Component} from '@angular/core';
import {CustomCarouselComponent} from '../../shared/components/carousel/custom.carousel.component';
import {RouterModule, RouterOutlet} from "@angular/router";
import {LoadingBarHttpClientModule} from "@ngx-loading-bar/http-client";
import {AuthTopBarComponent} from './top-bar/auth-top-bar.component';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-authentication-template',
  templateUrl: './authentication-template.component.html',
  styleUrl: './authentication-template.component.scss',
  imports: [CustomCarouselComponent, RouterOutlet, RouterModule, LoadingBarHttpClientModule, AuthTopBarComponent, MatIconModule]
})
export class AuthenticationTemplateComponent {

}
